import AutoplayModel from "../../../core/src/model/AutoplayModel";
import PointerEvents from "../../../core/src/const/PointerEvents";
import AbstractPopup from "../../../core/src/ui/popups/AbstractPopup";
import BetModel from "../../../core/src/model/BetModel";
import ViewManager from "../../../core/src/utils/ViewManager";
import SoundController from "../../../core/src/utils/SoundController";
import SoundVars from "../../../core/src/const/SoundVars";
import CommandManager from "../../../core/src/commands/CommandManager";
import { Commands } from "../../../core/src/commands/CommandEnum";
import SwitchButton from "../../../core/src/views/components/SwitchButton";
import GameModel from "../../../core/src/model/GameModel";
import Checkbox from "../../../core/src/views/components/Checkbox";
import Button from "../../../core/src/views/components/Button";
import SwitchGroup from "../../../core/src/views/components/SwitchGroup";
import { VendorSettingsButtons } from "../../const/VendorSettingsButtons";
import { VendorCommandsEnum } from "../../commands/VendorCommandsEnum";
import Slider, { SliderOrientation } from "../../../core/src/views/components/Slider";
import ReelGroup from "../../../core/src/views/ReelGroup";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import App from "../../../core/src/App";
import VendorModel from "../../model/VendorModel";
import Configs from "../../vendorConfigs/Configs";
import Layout from "../../../core/src/utils/Layout";


export default class AutoplayPopup extends AbstractPopup {

    protected sceneName = "autoplay";
    // protected lossLimitsPopup:PIXI.Container;
    protected playBtn: Button;
    protected clearBtn: Button;
    protected autoSpins: SwitchGroup;
    protected stopOnFeatureCheckBox:Checkbox;
    protected stopOnBigWinCheckBox:Checkbox;
    protected spinsSelected: number = 0;
    protected isFeatureAllowed: boolean;
    protected lossLimitSlider: Slider;
    protected winLimitSlider: Slider;
    protected singleWinLimitSlider: Slider;
    protected swipReelsWasAllowed: boolean;

    constructor() {
        super();
        this.create();
        this.layer = ViewManager.getLayer("BetBarPopups");
    }

    public show(full: boolean = false) {
        super.show();
        this.swipReelsWasAllowed = VendorModel.allowSwipeSpin;
        this.scene = this.layer.setScene(this.sceneName);
        this.spinsSelected = AutoplayModel.initialAutospinNum;
        this.autoSpins = this.scene.buttonGroups.get("spinsCount");
        this.isFeatureAllowed = !GameModel.gameConfig.disableAutoplay;
        this.clearBtn = this.scene.buttons.get("clear");
        this.playBtn = this.scene.buttons.get("play");

        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;

        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, true);
        if(this.swipReelsWasAllowed) {
            reelGroup.disableSwipeSpin();
        }
        //-------------- stop on any win -----------------
        let stopAnyWinToggle = this.scene.buttons.get(VendorSettingsButtons.STOP_ON_ANY_WIN) as SwitchButton;
        stopAnyWinToggle.on(PointerEvents.DOWN, () => {
            stopAnyWinToggle.toggle();
            CommandManager.execute(Commands.TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN);
            AutoplayModel.initialStopOnAnyWin =  stopAnyWinToggle.isSelected();
        });
        stopAnyWinToggle.switch(AutoplayModel.initialStopOnAnyWin);
        AutoplayModel.stopOnAnyWin = AutoplayModel.initialStopOnAnyWin;
        //-------------------------------------------------


        /*this.stopOnFeatureCheckBox = new Checkbox(
            this.scene.sceneSprites.get("box-stop_on_feature"),
            this.scene.sceneSprites.get("check-stop_on_feature"),
            this.scene.sceneTextFields.get("stop_on_feature")
        );
        this.stopOnBigWinCheckBox = new Checkbox(
            this.scene.sceneSprites.get("box-stop_on_big_win"),
            this.scene.sceneSprites.get("check-stop_on_big_win"),
            this.scene.sceneTextFields.get("stop_on_big_win")
        );*/

        ////////////////
        // AUTO SPIN COUNT
        ////////////////
        let autoSpinValues = Configs.game.clientConfig.autoplayRounds;

        if (!autoSpinValues || autoSpinValues.length == 0) {
            autoSpinValues = [5, 10, 25, 50, 100];
        }

        // debugger;
        this.autoSpins.replaceButtonTexts((value, index) =>
            autoSpinValues[index] ?
                String(autoSpinValues[index]) :
                null
        );

        // Loop through the values to select the current one
        this.autoSpins.getChildren().forEach((child: SwitchButton) => {
            child.setEnabled(this.isFeatureAllowed);
            child.switch(
                parseFloat(child.getValue()) == AutoplayModel.initialAutospinNum
            );
        });

        if (App.config.labelSettings?.autoplayButtons) {
            this.applayLabelSettings();
        }
        //-------------single win limit-----------------
        let singleWinLimitCounter = this.scene.sceneTextFields.get("single_win_limit_count");
        singleWinLimitCounter.text = "0";
        this.singleWinLimitSlider = new Slider({
            handle:this.scene.buttons.get(
                "single_win_limit_slider_handle"
            ),
            fill:this.scene.sceneSprites.get("single_win_limit_slider_track"),
            track:this.scene.sceneSprites.get("single_win_limit_slider_holder"),
        },SliderOrientation.Horizontal, false, null, "single_win_limit");
        this.singleWinLimitSlider.on(PointerEvents.UPDATE,() => {
            let value: number = Number(((Number(this.singleWinLimitSlider.getValue())) * (BetModel.totalBet / App.config.subUnits)).toFixed(2));
            singleWinLimitCounter.text = value.toString();
            this.updatePlayButton();
        });
        this.singleWinLimitSlider.setValue(this.ensureRange(AutoplayModel.initialWinLimit / App.config.subUnits));
        //----------------------------------------------
        //---------------win limit(tottal)--------------
        let winLimitCounter = this.scene.sceneTextFields.get("win_limit_count");
        winLimitCounter.text = "0";
        this.winLimitSlider = new Slider({
            handle:this.scene.buttons.get(
                "win_limit_slider_handle"
            ),
            fill:this.scene.sceneSprites.get("win_limit_slider_track"),
            track:this.scene.sceneSprites.get("win_limit_slider_holder"),
        },SliderOrientation.Horizontal, false, null, "win_limit_slider")
        this.winLimitSlider.on(PointerEvents.UPDATE,() => {
            let value: number = Number((Number(this.winLimitSlider.getValue()) * (BetModel.totalBet / App.config.subUnits)).toFixed(2));
            winLimitCounter.text = value.toString();
            this.updatePlayButton();
        });
        this.winLimitSlider.setValue(this.ensureRange(AutoplayModel.initialTotalWinLimit / App.config.subUnits));
        //----------------------------------------------
        //-------------------loss limit-----------------
        let lossLimitCounter = this.scene.sceneTextFields.get("loss_limit_count");
        lossLimitCounter.text = "0";
        this.lossLimitSlider = new Slider({
            handle:this.scene.buttons.get(
                "loss_limit_slider_handle"
            ),
            fill:this.scene.sceneSprites.get("loss_limit_slider_track"),
            track:this.scene.sceneSprites.get("loss_limit_slider_holder"),
        },SliderOrientation.Horizontal, false, null, "loss_limit_slider")
        this.lossLimitSlider.on(PointerEvents.UPDATE,() => {
            let value: number = Number((Number(this.lossLimitSlider.getValue()) * (BetModel.totalBet / App.config.subUnits)).toFixed(2));
            lossLimitCounter.text = value.toString();
            this.updatePlayButton();
        });
        this.lossLimitSlider.setValue(this.ensureRange(AutoplayModel.initialLossLimit / App.config.subUnits));
        //----------------------------------------------

        this.autoSpins.onSelect((value) => {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            value = Number(value.split("x")[0]);
            AutoplayModel.setAutoSpin(value);
            this.updatePlayButton();
            this.applyLabelStyle();
            // saveSettings();
        });

        /*this.stopOnBigWinCheckBox.setIsSelected(AutoplayModel.stopOnBigWin);

        this.stopOnBigWinCheckBox.on(PointerEvents.UPDATE,()=>{
            CommandManager.execute(Commands.TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN);
        });

        this.stopOnFeatureCheckBox.setIsSelected(AutoplayModel.stopOnFeatureWin);
        this.stopOnFeatureCheckBox.on(PointerEvents.UPDATE,()=>{
            CommandManager.execute(Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN);
        });*/


        if(this.scene.sceneSprites.has('background')) {
            let bg = this.scene.sceneSprites.get('background');
            bg.interactive = true;
        }

        this.updatePlayButton();

        this.playBtn.on(PointerEvents.DOWN, () => {
            AutoplayModel.initialWinLimit = Number(this.singleWinLimitSlider.getValue()) * App.config.subUnits;
            AutoplayModel.initialTotalWinLimit = Number(this.winLimitSlider.getValue()) * App.config.subUnits;
            AutoplayModel.initialLossLimit = Number(this.lossLimitSlider.getValue()) * App.config.subUnits;
            CommandManager.execute(Commands.SET_AUTOPLAY_SINGLE_WIN_LIMIT, AutoplayModel.initialWinLimit * BetModel.totalBet / App.config.subUnits);
            CommandManager.execute(Commands.SET_AUTOPLAY_TOTAL_WIN_LIMIT, AutoplayModel.initialTotalWinLimit * BetModel.totalBet / App.config.subUnits);
            CommandManager.execute(Commands.SET_AUTOPLAY_LOSS_LIMIT, AutoplayModel.initialLossLimit * BetModel.totalBet / App.config.subUnits);
            AutoplayModel.initialStopOnAnyWin = stopAnyWinToggle.isSelected();

            CommandManager.execute(Commands.SAVE_SETTINGS);

            AutoplayModel.setAutoSpin(AutoplayModel.initialAutospinNum);
            CommandManager.execute(Commands.START_AUTOPLAY);
            CommandManager.execute(Commands.TOGGLE_AUTOPLAY_POPUP, true);
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        }, this);

        this.assignInterraction(
            Commands.TOGGLE_AUTOPLAY_POPUP,
            this.clearBtn,
            SoundVars.BUTTON_CLICK,
            true
        );

        this.scene.orientationChangeCallback = () => {
            if (App.config.labelSettings?.autoplayButtons) {
                this.applayLabelSettings();
            }
        }
    }

    updatePlayButton(){
        let enabled =
            this.isFeatureAllowed &&
            this.autoSpins.isSelected()/* &&
            AutoplayModel.getLossLimit() > 0*/
        this.playBtn.setEnabled(enabled);
    };

    protected buildLossLimitPopup(){

    }

    public hide() {
        if(this.swipReelsWasAllowed) {
            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            reelGroup.enableSwipeSpin();
        }

        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
        this.singleWinLimitSlider.destroy();
        this.lossLimitSlider.destroy();
        this.winLimitSlider.destroy();
        super.hide();
    }

    update(event) {
        // if (this.scene && event == UIUpdateEvent.Autoplay) {
        //     let featureBtn = this.scene.buttons.get('stopOnFeatureWin') as SwitchButton;
        //     let anyWinBtn = this.scene.buttons.get('stopOnAnyWin') as SwitchButton;
        //     if (featureBtn && anyWinBtn) {
        //         featureBtn.switch(AutoplayModel.stopOnFeatureWin);
        //         anyWinBtn.switch(AutoplayModel.stopOnAnyWin);
        //     }
        // }
    }

    private ensureRange(value: number) {
        return Math.min(100, Math.max(0, value));
    }

    // if we have special color for selected and no selected state, on buttons text
    private applyLabelStyle() {
        if (App.config.autoPlayBtnLblStatesColor) {
            this.autoSpins.getChildren().forEach((child: SwitchButton) => {
                if (child.isSelected()) {
                    child.text.style.fill = App.config.autoPlayBtnLblStatesColor?.selected
                } else {
                    child.text.style.fill = App.config.autoPlayBtnLblStatesColor?.base
                }
            })
        }
    }

    private applayLabelSettings() {
        const settings = App.config.labelSettings.autoplayButtons
        this.autoSpins.getChildren().forEach((child: SwitchButton) => {

            if (child.text && child.butImg) {
                const width = Layout.getWidth(child.butImg) * settings.scaleX;
                const height = Layout.getHeight(child.butImg) * settings.scaleY;
                let bounds = {
                    x: Layout.getX(child.butImg) + settings.offsetX * width,
                    y: Layout.getY(child.butImg) + settings.offsetY * height,
                    width: width,
                    height: height
                };
                child.text.anchor.set(child.butImg.anchor.x, child.butImg.anchor.y);
                child.text.boundAnchor = {x: (0.5 - child.butImg.anchor.x), y: (0.5 - child.butImg.anchor.y)};

                child.text.bound = bounds;
                child.text.applyBound();
                this.applyLabelStyle();
            }
        });
    }
}
